"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

function future() {
  var resolver;
  var rejecter;
  var promise = new Promise(function (ok, err) {
    resolver = function resolver(x) {
      ok(x);
      promise.isPending = false;
    };

    rejecter = function rejecter(x) {
      err(x);
      promise.isPending = false;
    };
  }).catch(function (e) {
    return Promise.reject(e);
  });
  promise.resolve = resolver;
  promise.reject = rejecter;

  if (!("finally" in promise)) {
    promise.finally = function (fn) {
      promise.then(fn);
      promise.catch(fn);
    };
  }

  promise.isPending = true;
  return promise;
}

exports.future = future;
exports.default = future;